import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'

import Auth from 'pages/Auth/Auth.page'
import OAuth from 'pages/Auth/OAuth.page'

const AuthRoute = () => {
    const isAuth = useSelector(state => !!state.user_details)

    if (isAuth) return <Redirect to={{ pathname: '/my-projects' }} />

    return (
        <>
            <Route path="/auth" component={Auth} />
            <Route path="/oauth2/redirect" component={OAuth} />
        </>
    )
}

export default AuthRoute
